module.exports = __webpack_public_path__ + "img/soth-trivia-screen-clear.717b40ae.png";